import { obtenerUsuarioSesion } from './sesion';

export function obtenerUsuarioActual() {
  return obtenerUsuarioSesion();
}

export function obtenerRolActual() {
  const usuario = obtenerUsuarioActual();

  return usuario.Rol || usuario.rol || '';
}

export function esAdministrador() {
  return obtenerRolActual() === 'Administrador';
}

export function esOperador() {
  return obtenerRolActual() === 'Operador';
}

export function esRolAdministrativo() {
  const rol = obtenerRolActual();
  return rol === 'Administrador' || rol === 'Operador';
}
